/* Epione Skin Care: add to bag without leaving the page, routine bundles, in-view video. Oct 2026. */
(function () {
  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }
  function drawer() { return document.querySelector('cart-drawer'); }
  function addItems(items, btn, fallbackForm) {
    var cd = drawer();
    var sections = [];
    if (cd && typeof cd.getSectionsToRender === 'function') {
      sections = cd.getSectionsToRender().map(function (s) { return s.id; });
    }
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { throw state; }
        if (cd && typeof cd.renderContents === 'function') {
          cd.classList.remove('is-empty');
          cd.renderContents(state);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        if (fallbackForm) { fallbackForm.submit(); return; }
        if (btn) {
          var msg = (err && (err.description || err.message)) || 'Could not add to bag. Please try again.';
          btn.setAttribute('title', msg);
          var note = btn.parentNode.querySelector('.ep-add-error');
          if (!note) { note = document.createElement('p'); note.className = 'ep-add-error'; note.setAttribute('role', 'alert'); btn.parentNode.appendChild(note); }
          note.textContent = msg;
        }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ep-add]')) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    addItems([{ id: Number(id), quantity: 1 }], form.querySelector('[type="submit"]'), form);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ep-add-items]');
    if (!btn) return;
    e.preventDefault();
    var items = [];
    try { items = JSON.parse(btn.getAttribute('data-ep-add-items')); } catch (err) { items = []; }
    if (items.length) addItems(items, btn);
  });

  /* Videos play only while on screen, never for reduced-motion visitors, and pause on request. */
  function initReels() {
    var reels = document.querySelectorAll('[data-ep-reel]');
    if (!reels.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    reels.forEach(function (reel) {
      var videos = Array.prototype.slice.call(reel.querySelectorAll('video'));
      var toggle = reel.parentNode.querySelector('[data-ep-reel-toggle]');
      var paused = reduce;
      function sync(v, visible) {
        if (!paused && visible) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      }
      var seen = new WeakMap();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); sync(en.target, en.isIntersecting); });
        }, { threshold: 0.4 });
        videos.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); io.observe(v); });
      }
      if (toggle) {
        function label() {
          toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          toggle.textContent = paused ? 'Play videos' : 'Pause videos';
        }
        label();
        toggle.addEventListener('click', function () {
          paused = !paused; label();
          videos.forEach(function (v) { sync(v, seen.get(v)); });
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReels); else initReels();
})();

/* v2: move product extras under the buy box, free-shipping progress in the cart drawer. */
(function () {
  function moveExtras() {
    var x = document.querySelector('.epx');
    var info = document.querySelector('product-info');
    var sec = info && info.closest('.shopify-section');
    if (x && sec && sec.nextElementSibling !== x) sec.after(x);
  }
  var FREE = 5000;
  function shipBar() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    var host = cd.querySelector('.drawer__header');
    if (!host) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var el = cd.querySelector('.ep-ship');
        if (!el) { el = document.createElement('div'); el.className = 'ep-ship'; host.insertAdjacentElement('afterend', el); }
        if (!c.item_count) { if (!el.hidden) el.hidden = true; return; }
        var left = FREE - c.total_price;
        var pct = Math.max(4, Math.min(100, Math.round(c.total_price / FREE * 100)));
        var msg = left > 0 ? 'You are $' + (left / 100).toFixed(2) + ' away from complimentary US shipping.' : 'Your order ships free within the US.';
        var html = '<p>' + msg + '</p><span class="ep-ship__bar" aria-hidden="true"><i style="width:' + pct + '%"></i></span>';
        if (el.innerHTML !== html) el.innerHTML = html;
        el.hidden = false;
      })
      .catch(function () {});
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(shipBar, 120); }
  function init() {
    moveExtras();
    var cd = document.querySelector('cart-drawer');
    if (cd && 'MutationObserver' in window) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          var n = ms[i].target;
          if (n.closest && n.closest('.ep-ship')) continue;
          later(); return;
        }
      }).observe(cd, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      shipBar();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* v4: one-tap "Pairs well with" suggestions in the cart drawer (Shopify related products, items already in the bag excluded). */
(function(){
  var busy=false,pending=false,lastKey='',t;
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function money(c){return '$'+(c/100).toFixed(2);}
  function run(){
    var cd=document.querySelector('cart-drawer');
    if(!cd||!cd.classList.contains('active'))return;
    if(busy){pending=true;return;}
    busy=true;
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var old=cd.querySelector('.ep-recs');
      if(!cart.items.length){if(old)old.remove();lastKey='';return;}
      var key=cart.items.map(function(i){return i.product_id;}).join(',');
      if(old&&key===lastKey)return;
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      return fetch(root+'recommendations/products.json?product_id='+cart.items[0].product_id+'&limit=8&intent=related').then(function(r){return r.json();}).then(function(d){
        lastKey=key;
        var inCart={};cart.items.forEach(function(i){inCart[i.product_id]=1;});
        var picks=(d.products||[]).filter(function(p){return p.available&&!inCart[p.id]&&!/gift card|set of 8/i.test(p.title);}).slice(0,2);
        var cur=cd.querySelector('.ep-recs');if(cur)cur.remove();
        if(!picks.length)return;
        var anchor=cd.querySelector('cart-drawer-items');if(!anchor)return;
        var w=document.createElement('div');w.className='ep-recs';
        w.innerHTML='<p class="ep-recs__h">Pairs well with</p>'+picks.map(function(p){
          var v=p.variants.filter(function(x){return x.available;})[0]||p.variants[0];
          var img=p.featured_image?p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=120':'';
          return '<div class="ep-recs__i"><span class="ep-recs__img">'+(img?'<img src="'+esc(img)+'" alt="" width="44" height="44" loading="lazy">':'')+'</span><a href="'+esc(p.url)+'">'+esc(p.title.replace(/^EPIONE\s+/i,''))+'<span>'+money(v.price)+'</span></a><button type="button" class="ep-recs__add" aria-label="Add '+esc(p.title)+' to bag" data-ep-add-items=\'[{"id":'+Number(v.id)+',"quantity":1}]\'>Add</button></div>';
        }).join('');
        anchor.insertAdjacentElement('afterend',w);
      });
    }).catch(function(){}).finally(function(){busy=false;if(pending){pending=false;later();}});
  }
  function later(){clearTimeout(t);t=setTimeout(run,180);}
  function init(){
    var cd=document.querySelector('cart-drawer');
    if(!cd||!('MutationObserver' in window))return;
    new MutationObserver(function(ms){
      for(var i=0;i<ms.length;i++){var n=ms[i].target;if(!(n.closest&&(n.closest('.ep-recs')||n.closest('.ep-ship')))){later();return;}}
    }).observe(cd,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();


/* v6: keep the accessibility/consent button clear of the sticky add-to-bag bar */
(function(){
  var CSS='.cw-trigger.cw-pos-bottom-left,.cw-trigger.cw-pos-bottom-right{bottom:calc(22px + var(--ep-lift,0px))!important;transition:bottom .3s cubic-bezier(.2,.7,.2,1)}'+
          '.cw-panel.cw-a11y-panel{bottom:calc(62px + var(--ep-lift,0px))!important;max-height:calc(100vh - 110px - var(--ep-lift,0px))!important}';
  function host(){return document.getElementById('cw-widget-root');}
  function inject(){var h=host();if(!h||!h.shadowRoot)return false;if(!h.shadowRoot.getElementById('ep-lift')){var st=document.createElement('style');st.id='ep-lift';st.textContent=CSS;h.shadowRoot.appendChild(st);}return true;}
  function sync(){
    var h=host();if(!h)return;inject();
    var lift=0,bar=document.querySelector('[data-epx-bar]');
    if(bar&&bar.classList.contains('is-on')){lift=Math.ceil(bar.getBoundingClientRect().height);}
    h.style.setProperty('--ep-lift',lift+'px');
  }
  function init(){
    var bar=document.querySelector('[data-epx-bar]');
    if(bar&&'MutationObserver' in window)new MutationObserver(sync).observe(bar,{attributes:true,attributeFilter:['class']});
    window.addEventListener('resize',sync,{passive:true});
    var n=0,t=setInterval(function(){sync();if(inject()||++n>60)clearInterval(t);},300);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* v6: product films. Load only when near the viewport, play muted while visible, pause control, no autoplay with reduced motion */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(v){
    var btn=v.parentNode.querySelector('[data-ep-film-btn]');
    var userPaused=reduce,loaded=false,visible=false;
    function load(){if(loaded)return;var s=v.querySelector('source[data-src]');if(s){s.src=s.getAttribute('data-src');s.removeAttribute('data-src');}v.load();loaded=true;}
    function state(){if(btn){var paused=v.paused;btn.setAttribute('aria-pressed',paused?'true':'false');btn.setAttribute('aria-label',paused?'Play video':'Pause video');}}
    function play(){load();var p=v.play();if(p&&p.catch)p.catch(function(){});}
    v.addEventListener('play',state);v.addEventListener('pause',state);state();
    if(btn)btn.addEventListener('click',function(){if(v.paused){userPaused=false;play();}else{userPaused=true;v.pause();}});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        en.forEach(function(e){visible=e.isIntersecting;if(visible){load();if(!userPaused)play();}else if(!v.paused){v.pause();}});
      },{rootMargin:'200px 0px',threshold:0.35}).observe(v);
    }else{load();if(!userPaused)play();}
  }
  function init(){[].forEach.call(document.querySelectorAll('video[data-ep-film]'),setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();


/* v7: theme the ComplyMo widget (cookie banner + accessibility panel) to the Epione palette and type */
(function(){
  var CSS=':host{font-family:var(--font-body-family,Inter,system-ui,sans-serif)!important}'+
    'div[style*="--cw-accent"]{--cw-accent:#000b1b!important;--cw-accent-contrast:#f7f3ec!important;--cw-radius:16px!important;--cw-btn-radius:999px!important;'+
    '--cw-bg:rgba(247,243,236,.94)!important;--cw-bg-solid:#f7f3ec!important;--cw-fg:#000b1b!important;--cw-muted:#57534d!important;'+
    '--cw-border:rgba(255,255,255,.65)!important;--cw-stroke:rgba(0,11,27,.10)!important;--cw-track:rgba(0,11,27,.14)!important;--cw-elev:rgba(255,255,255,.75)!important;'+
    '--cw-shadow:0 22px 50px -18px rgba(0,11,27,.38)!important}'+
    'h1,h2,h3,h4{font-family:var(--font-heading-family,"Cormorant Garamond",Georgia,serif)!important;font-weight:400!important;letter-spacing:0!important;font-size:24px!important;line-height:1.15!important}'+
    '.cw-btn{font-family:inherit!important;font-size:12px!important;font-weight:500!important;letter-spacing:.1em!important;text-transform:uppercase!important;padding:11px 16px!important}'+
    '.cw-trigger{background:#000b1b!important;color:#d4b77c!important;box-shadow:0 0 0 1px rgba(212,183,124,.5),0 10px 24px -8px rgba(0,11,27,.55)!important}'+
    'a{color:inherit}';
  function inject(){var h=document.getElementById('cw-widget-root');if(!h||!h.shadowRoot)return false;if(!h.shadowRoot.getElementById('ep-theme')){var st=document.createElement('style');st.id='ep-theme';st.textContent=CSS;h.shadowRoot.appendChild(st);}return true;}
  function init(){var n=0,t=setInterval(function(){if(inject()||++n>60)clearInterval(t);},300);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
